import React from 'react';
import { SaveMetaDeliveryForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type SaveMetaDeliveryModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveMetaDeliveryModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save meta delivery'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveMetaDeliveryForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );
};
